/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMale = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM9 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3 6a3 3 0 0 1 3 3v2h-2v4h-2v-4H9v-2a3 3 0 0 1 3-3zm3 7h2v-4a5 5 0 0 0-10 0v4h2v4h6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMale as Male };
